module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/grace-fortier-587b85278f614fd005f6b9261eedb605.jpg";